<template>
  <div
    v-if="formData"
    class="fin-form solid-table"
    :class="{ dark: theme === 'dark' }"
  >
    <div class="fin-form-header" v-if="!backend">
      {{ nameLabel || '--' }}
    </div>
    <div class="fin-form-content">
      <el-form size="mini" :inline="true" :model="formData" label-suffix="：">
        <el-collapse v-model="collapseModel">
          <el-collapse-item title="基础信息" name="type">
            <el-form-item label="方案名称" prop="name">
              {{ formData.name }}
            </el-form-item>
            <el-form-item label="风场类型" prop="landOrSea">
              {{ (formData.landOrSea === 1 ? '陆地风场' : '海上风场') || '--' }}
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="关键指标" name="important">
            <el-form-item label="运营期（年）">
              {{ formData.operatingPeriod }}
            </el-form-item>
            <el-form-item label="建设期（年）">
              {{ formData.constructionPeriod }}
            </el-form-item>
            <el-form-item label="装机容量（MW）" prop="cap" ref="cap">
              {{ formData.cap }}
            </el-form-item>

            <el-form-item label="静态总投资（万元）">
              {{ formData.staticTotalInvestment || '--' }}
            </el-form-item>
            <el-form-item label="资本金比例（%）">
              {{ formData.capitalRate }}
            </el-form-item>
            <el-form-item label="长期贷款利率（%）">
              {{ formData.loanInterestRate }}
            </el-form-item>
            <el-form-item label="满发小时数（h）">
              {{ formData.equivalentHour }}
            </el-form-item>
            <el-form-item label="含税电价（元/kwh）">
              {{ formData.priceWith }}
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="基本参数" name="basic">
            <el-divider content-position="left">年限和装机容量</el-divider>
            <el-form-item label="运营期（年）">
              {{ formData.operatingPeriod }}
            </el-form-item>
            <el-form-item label="建设期（年）">
              {{ formData.constructionPeriod }}
            </el-form-item>
            <el-form-item label="开工年份">
              {{ formData.constructionStarttime }}
            </el-form-item>
            <el-form-item label="装机容量（MW）">
              {{ formData.cap }}
            </el-form-item>

            <el-divider content-position="left">建设期分年度投资</el-divider>
            <el-form-item label="静态总投资（万元）">
              {{ formData.staticTotalInvestment || '--' }}
            </el-form-item>
            <items
              label="分年度投资（万元）"
              :value="formData.constructionInvestArr"
            ></items>
            <el-form-item label="可抵扣增值税比例（%）">
              {{ formData.vatRate }}
            </el-form-item>
            <items
              label="无形资产（万元）"
              :value="formData.immaterialAssetsArr"
            />
            <items label="其他资产（万元）" :value="formData.otherAssetsArr" />

            <el-divider content-position="left">资本金投入</el-divider>
            <el-form-item label="资本金比例（%）">
              {{ formData.capitalRate }}
            </el-form-item>
            <el-form-item label="资本金基准收益率-贴现率（%）">
              {{ formData.marr }}
            </el-form-item>
            <el-form-item label="行业基准收益率(所得税前)（%）">
              {{ formData.marrBeforeTax }}
            </el-form-item>
            <el-form-item label="行业基准收益率(所得税后)（%）">
              {{ formData.marrAfterTax }}
            </el-form-item>

            <el-divider content-position="left">流动资金及短期贷款</el-divider>
            <el-form-item label="单位千瓦流动资金（元/kw）">
              {{ formData.fluidUnit }}
            </el-form-item>
            <el-form-item label="流动资金贷款比例（%）">
              {{ formData.fluidLoanRatio }}
            </el-form-item>
            <el-form-item label="流动资金贷款利率（%）">
              {{ formData.fluidLoanRate }}
            </el-form-item>
            <el-form-item label="短期贷款利率（%）">
              {{ formData.shortLoanRate }}
            </el-form-item>

            <el-divider content-position="left">长期借款利息</el-divider>
            <el-form-item label="贷款年限（年）">
              {{ formData.repaymentPeriod }}
            </el-form-item>
            <el-form-item label="还款类型（%）">
              {{ ['等额本息', '等额本金'][formData.repayType] }}
            </el-form-item>
            <el-form-item label="长期贷款利率（%）">
              {{ formData.loanInterestRate }}
            </el-form-item>
          </el-collapse-item>
          <el-collapse-item title="成本费用" name="cost">
            <el-divider content-position="left">折旧费</el-divider>
            <el-form-item label="残值率（%）">
              {{ formData.salvage }}
            </el-form-item>
            <el-form-item label="折旧数据类型">
              {{
                ['折旧年限', '综合折旧率', '手动输入折旧费（建设期+运营期）'][
                  formData.depreciableType
                ]
              }}
            </el-form-item>
            <el-form-item
              v-if="+formData.depreciableType !== 2"
              :label="
                ['折旧年限（年）', '综合折旧率（%）', '折旧费（万元）'][
                  formData.depreciableType
                ]
              "
            >
              {{ formData.depreciableData }}
            </el-form-item>
            <items
              v-if="+formData.depreciableType === 2"
              :value="formData.depreciableDataArr"
              :label="
                ['折旧年限（年）', '综合折旧率（%）', '折旧费（万元）'][
                  formData.depreciableType
                ]
              "
            />

            <el-divider content-position="left">维修费</el-divider>
            <el-form-item label="维修数据单位">
              {{ ['%', '元/kw', '万元'][formData.maintainType] }}
            </el-form-item>
            <el-form-item label="数据维数">
              {{
                ['各年相同', '各年不同（建设期+运营期）'][formData.maintainNum]
              }}
            </el-form-item>
            <el-form-item
              v-if="+formData.maintainNum === 0"
              :label="
                `${['维修费率', '单位维修费', '维修费'][formData.maintainType]}`
              "
            >
              {{ formData.maintainData }}
            </el-form-item>
            <items
              v-if="+formData.maintainNum === 1"
              :value="formData.maintainDataArr"
              :label="
                `${['维修费率', '单位维修费', '维修费'][formData.maintainType]}`
              "
            >
            </items>

            <el-divider content-position="left">人工工资及福利</el-divider>
            <el-form-item label="人员种类">
              {{ formData.staffTypeNum }}
            </el-form-item>
            <items
              :values="formData.staffCapacityArr"
              label="人员数量"
              unit="种"
            >
            </items>
            <items
              :value="formData.staffSalaryArr"
              label="人均年平均工资（万元/年）"
              unit="种"
            >
            </items>
            <items
              :value="formData.welfareRateArr"
              label="福利系数（%）"
              unit="种"
            >
            </items>

            <el-divider content-position="left">保险费</el-divider>
            <el-form-item label="保险数据单位">
              {{ ['%', '元/kw', '万元'][formData.insureType] }}
            </el-form-item>
            <el-form-item label="保险计算方式">
              {{
                ['各年相同', '各年不同（建设期+运营期）'][formData.insureNum]
              }}
            </el-form-item>
            <el-form-item label="保险计算基数">
              {{ ['固定资产原值', '固定资产净值'][formData.insureRaw] }}
            </el-form-item>
            <el-form-item
              v-if="+formData.insureNum === 0"
              :label="
                `${['保险费率', '单位保险费', '保险费'][formData.insureType]}`
              "
            >
              {{ formData.insureData }}
            </el-form-item>
            <items
              v-if="+formData.insureNum === 1"
              :value="formData.insureDataArr"
              :label="
                `${['保险费率', '单位保险费', '保险费'][formData.insureType]}`
              "
            >
            </items>

            <el-divider content-position="left">材料费</el-divider>
            <el-form-item label="材料费数据单位">
              {{ ['%', '元/kw', '万元'][formData.materialType] }}
            </el-form-item>
            <el-form-item label="材料费计算方式">
              {{
                ['各年相同', '各年不同（建设期+运营期）'][formData.materialNum]
              }}
            </el-form-item>
            <el-form-item
              v-if="+formData.materialNum === 0"
              :label="
                `${['材料费率', '单位材料费', '材料费'][formData.materialType]}`
              "
            >
              {{ formData.materialConsumption }}
            </el-form-item>
            <items
              v-if="+formData.materialNum === 1"
              :value="formData.materialConsumptionArr"
              :label="
                `${['材料费率', '单位材料费', '材料费'][formData.materialType]}`
              "
            >
            </items>

            <el-divider content-position="left">摊销费</el-divider>
            <el-form-item label="无形资产摊销年限（年）">
              {{ formData.immaterialAmortization }}
            </el-form-item>
            <el-form-item label="其他资产摊销年限（年）">
              {{ formData.otherAmortization }}
            </el-form-item>

            <el-divider content-position="left">其他费用</el-divider>
            <el-form-item label="其他费用计算方式">
              {{
                ['各年相同', '各年不同（建设期+运营期）'][formData.otherFeeNum]
              }}
            </el-form-item>
            <el-form-item label="其他费用1单位">
              {{ ['元/kw', '万元'][formData.otherFeeType1 - 1] }}
            </el-form-item>
            <el-form-item v-if="+formData.otherFeeNum === 0" label="其他费用1">
              {{ formData.otherFee1 }}
            </el-form-item>
            <items
              v-if="+formData.otherFeeNum === 1"
              :value="formData.otherFee1Arr"
              label="其他费用1"
            ></items>
            <el-form-item label="其他费用2单位">
              {{ ['元/kw', '万元'][formData.otherFeeType2 - 1] }}
            </el-form-item>
            <el-form-item v-if="+formData.otherFeeNum === 0" label="其他费用2">
              {{ formData.otherFee2 }}
            </el-form-item>
            <items
              v-if="+formData.otherFeeNum === 1"
              :value="formData.otherFee2Arr"
              label="其他费用2"
            >
            </items>
          </el-collapse-item>

          <el-collapse-item title="收入和税金" name="income">
            <el-divider content-position="left">产量</el-divider>
            <el-form-item label="等效利用小时数（h）">
              {{ formData.equivalentHour }}
            </el-form-item>
            <el-form-item label="上网电量计算方式">
              {{ ['自动计算', '手动输入'][formData.energyType] }}
            </el-form-item>
            <items
              :value="formData.energyData_Arr"
              :label="['发电量系数', '电量数据（kWH）'][formData.energyType]"
            >
            </items>

            <el-divider content-position="left">装机进度</el-divider>
            <items
              :value="formData.ongridCapacityArr"
              label="各年新增装机情况（MW）"
            >
            </items>

            <el-divider content-position="left">税率</el-divider>
            <el-form-item label="增值税率（%）">
              {{ formData.vat }}
            </el-form-item>
            <el-form-item label="所得税计算方式">
              {{ ['各年相同', '各年不同'][formData.incomeTaxType] }}
            </el-form-item>
            <el-form-item
              v-if="+formData.incomeTaxType === 0"
              label="企业所得税率（%）"
            >
              {{ formData.incomeTaxRate }}
            </el-form-item>
            <items
              v-if="+formData.incomeTaxType === 1"
              :value="formData.incomeTaxRateArr"
              label="企业所得税率（%）"
            >
            </items>

            <el-form-item label="城市维护建设费率（%）">
              {{ formData.urbanConstructionTaxRate }}
            </el-form-item>
            <el-form-item label="教育附加费（%）">
              {{ formData.educationAddRate }}
            </el-form-item>
            <el-form-item label="增值税即征即退">
              {{ ['无', '有'][formData.vatPolicy] }}
            </el-form-item>
            <el-form-item label="所得税N免（年）">
              {{ formData.incomeTaxNexempt }}
            </el-form-item>
            <el-form-item label="所得税N减半（年）">
              {{ formData.incomeTaxNhalved }}
            </el-form-item>
            <el-form-item label="法定盈余公积金比例（%）">
              {{ formData.proportionSurplusReserve }}
            </el-form-item>
            <el-form-item label="任意盈余公积金比例（%）">
              {{ formData.proportionSurplusDiscretionary }}
            </el-form-item>
            <el-form-item label="应付利润比例（%）">
              {{ formData.profitPayableRatio }}
            </el-form-item>

            <el-divider content-position="left">电价</el-divider>
            <el-form-item label="税类型">
              {{ ['所得税', '调整所得税'][formData.taxType] }}
            </el-form-item>
            <el-form-item label="含税电价（元/kwh）">
              {{ formData.priceWith }}
            </el-form-item>
            <el-form-item label="是否分两阶段电价">
              {{ ['否', '是'][formData.priceType] }}
            </el-form-item>
            <el-form-item
              label="第一阶段小时数（h）"
              v-if="+formData.priceType === 1"
            >
              {{ formData.hoursLimit }}
            </el-form-item>
            <el-form-item
              v-if="+formData.priceType === 1"
              label="第二阶段含税电价（元/kwh）"
            >
              {{ formData.priceWith2 }}
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="计算LCOE" name="lcoe">
            <el-form-item label="IRR类型">
              {{ ['项目投资税后收益率', '资本金收益率'][formData.irrType] }}
            </el-form-item>
            <el-form-item label="IRR大小">
              {{ formData.irrData }}
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="敏感性分析" name="sensitive">
            <el-form-item label="是否敏感性分析">
              {{ ['否', '是'][formData.whetherSense] }}
            </el-form-item>
            <div v-if="+formData.whetherSense === 1">
              <el-form-item label="总投资浮动（%）">
                {{
                  formData.totalInvestArr_Arr
                    ? formData.totalInvestArr_Arr.join(',')
                    : ''
                }}
              </el-form-item>
              <el-form-item label="电量浮动（%）">
                {{
                  formData.energyDataArr_Arr
                    ? formData.energyDataArr_Arr.join(',')
                    : ''
                }}
              </el-form-item>
              <el-form-item label="含税电价浮动（%）">
                {{
                  formData.priceWithArr_Arr
                    ? formData.priceWithArr_Arr.join(',')
                    : ''
                }}
              </el-form-item>
              <el-form-item label="长期贷款利率浮动（%）">
                {{
                  formData.loanInterestRateArr_Arr
                    ? formData.loanInterestRateArr_Arr.join(',')
                    : ''
                }}
              </el-form-item>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
  </div>
  <div v-else>
    <div class="fin-form empty-form">暂无数据</div>
  </div>
</template>

<script>
import Items from './items';

export default {
  components: {
    Items
  },
  props: {
    formData: {
      type: Object,
      default: () => null
    },
    project: {
      type: Object,
      default: () => null
    },
    economic: {
      type: Object,
      default: () => null
    },
    backend: {
      type: Boolean,
      default: () => false
    },
    theme: {
      type: String,
      default: () => 'dark'
    }
  },
  data() {
    return {
      collapseModel: [
        'relate',
        'important',
        'basic',
        'cost',
        'income',
        'type',
        'lcoe',
        'sensitive'
      ]
    };
  },
  computed: {
    nameLabel() {
      if (!this.economic) {
        return this.project?.label;
      }
      return this.economic.labelPath;
    }
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.fin-form {
  height: 100%;
  position: relative;

  .fin-form-header {
    padding: 1px 16px;
    display: flex;
    font-size: 16px;
    line-height: 30px;
    height: 30px;
  }

  .fin-form-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 28px;
    overflow: auto;
  }

  &.dark {
    .fin-form-header {
      background: @brandColor;
    }

    .fin-form-content {
      top: 30px;
      bottom: 30px;
    }

    /deep/.el-form-item {
      .el-form-item__label {
        color: #fff;
      }

      .el-form-item__content {
        color: #fff;
      }
    }

    /deep/.el-collapse {
      background: @bgColor;
      color: #fff;
      border-top: none;
      border-bottom: none;

      .el-collapse-item__header,
      .el-collapse-item__wrap {
        background: @bgColor;
        color: #fff;
        border-bottom: 1px solid @bgColor;
      }

      .el-collapse-item__header {
        background: #3271a1;
      }

      .el-form-item__label {
        color: #fff;
      }
    }
  }

  /deep/.el-form-item {
    .el-form-item__label {
      text-align: right;
      width: 230px;
    }

    .el-form-item__content {
      min-width: 200px;
    }
  }

  /deep/.el-collapse {
    .el-collapse-item__header,
    .el-collapse-item__wrap {
      padding-left: 16px;
    }

    .el-collapse-item__header {
      height: 30px;
    }

    .el-collapse-item__content {
      .el-form-item {
        width: 48%;
      }
    }
  }

  /deep/.el-divider {
    .el-divider__text {
      background: @bgColor;
      color: #fff;
    }
  }

  &.empty-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
    height: auto;
  }
}
</style>
